import { ArticleBatchDto } from "./article-batch.dto";
import { ArticleDto } from "./article.dto";
import { PackagingDto } from "./packaging.dto";
import { ProductionOrderProcessDto } from "./production-order-process.dto";
import { RawMaterialDto } from "./rawMaterial.dto";

export class FinalProductDto{

    id?: number;
    article?: ArticleDto;
    articleId?: number;
    articleBatch?: ArticleBatchDto;
    articleBatchId?: number;
    quantityToProduce!: number;
    quantityProduced?: number;
    axuliaryQuantityProduced?: number; // Introducido manualmente por el operario/encargado al finalizar un proceso manualmente
    packagings?: PackagingDto[];
    productionOrderProcess?: ProductionOrderProcessDto;
    productionOrderProcessId?: number;
    rawMaterials?: RawMaterialDto[];
}
